import { useState, useEffect, useCallback, useRef, memo } from "react";
import {
  TextField,
  Grid,
  InputAdornment,
  IconButton,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import * as Icons from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import Input from "../../Input";
import { colors } from "../../../theme/variables";
import { checkFormValidity } from "../../../utils/helpers";
import React from "react";
import { WorkflowErrors } from "../../../contexts/WorkflowErrors";

export const KeyValue = memo((props) => {
  const {
    classes,
    index,
    inputParameters = [],
    updateIpParameterVal,
    deleteIpParameterVal,
    keyVal,
    inputMode,
    headerOptions = [],
    loadedFrom = "",
    errors = {},
    uniqueKeys = {},
  } = props;

  const [taskErrors, setTaskErrors] = React.useContext(WorkflowErrors);
  const [key, setKey] = useState(keyVal[0] || "");
  const [value, setValue] = useState(keyVal[1] || "");
  const [error, seterror] = useState(false);
  const [inputError, setInputError] = useState("");
  // const renderCounter = useRef(0);
  // renderCounter.current += 1;
  // console.log(`KeyValue ${index} render count:`, renderCounter.current);
  useEffect(() => {
    const [key, val] = keyVal;
    if (!key && !val) return;
    if (keyVal) {
      setKey(key);
      setValue(val);
    }
  }, [keyVal]);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      if (key && value) {
        updateIpParameterVal(index, [key, value]);
      }
    }, 500);

    return () => clearTimeout(timeOut);
  }, [key, value]);

  useEffect(() => {
    if (loadedFrom === "CUSTOM_TASK") {
      const fieldObj = { name: "Header" };
      const propsObj = { taskReferenceName: `task-${index}` };
      let metaObj = { error: errors?.headers ? errors.headers : null };
      let metaObject = { error: error ? "Invalid Option" : null };
      checkFormValidity(fieldObj, metaObj, propsObj, taskErrors, setTaskErrors);
      checkFormValidity(
        fieldObj,
        metaObject,
        propsObj,
        taskErrors,
        setTaskErrors
      );
    }
  }, [loadedFrom, error, errors]);

  const handleKeyChange = (value) => {
    setKey(value);
    if (value && Object.keys(uniqueKeys).includes(value)) {
      setInputError("Key should be unique");
    } else {
      setInputError(false);
    }
  };

  const handleValueChange = (_, val) => {
    setValue(val);
  };

  const handleKeyAutoChange = (event, newKey) => {
    setKey(newKey || "");
  };
  const handleValueAutoChange = (newValue) => {
    setValue(newValue || "");
  };

  const renderJSX = (inputType) => {
    switch (inputType) {
      case "KeyValue":
        return (
          <Grid
            container
            spacing={2}
            alignItems="flex-end"
            justifyContent="center"
            key={index}
          >
            <Grid item xs={4}>
              <Input
                fullWidth
                value={key}
                onChange={handleKeyChange}
                error={!!inputError}
                label="Key"
              />
              {!!inputError && (
                <FormControl error={!!inputError}>
                  <FormHelperText>{inputError}</FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid item xs={7}>
              <Autocomplete
                id={`output-param-value-${index}`}
                options={
                  inputParameters.length
                    ? [
                        // eslint-disable-next-line no-template-curly-in-string
                        "${workflow.input}",
                        ...inputParameters.map(
                          (e) => "${workflow.input." + e + "}"
                        ),
                      ]
                    : // eslint-disable-next-line no-template-curly-in-string
                      ["${workflow.input}"]
                }
                clearOnBlur={false}
                freeSolo
                inputValue={value}
                onInputChange={(e, newVal) => handleValueChange(e, newVal)}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Value"
                    variant="outlined"
                    ref={params.InputProps.ref}
                    autoComplete="off"
                    InputProps={{
                      ...params.InputParams,
                      endAdornment: value && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => {
                              handleValueChange(null, "");
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={1}>
              <div
                className={classes.iconContainer}
                onClick={() => deleteIpParameterVal(index)}
                style={{ marginBottom: "0.5rem" }}
              >
                <Icons.DeleteOutlineOutlined />
              </div>
            </Grid>
          </Grid>
        );

      case "headers":
        return (
          <Grid
            container
            spacing={2}
            alignItems="baseline"
            justifyContent="center"
            key={index}
          >
            <Grid item xs={4}>
              <Autocomplete
                id={`output-param-value-${index}`}
                options={headerOptions}
                clearOnBlur={false}
                value={key}
                inputValue={key}
                onChange={(e, newKey) => handleKeyAutoChange(e, newKey)}
                onInputChange={(e, newKey) => handleKeyAutoChange(e, newKey)}
                freeSolo
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    autoComplete="off"
                    variant="outlined"
                    label="Key"
                    error={error} // Show error state
                    helperText={error ? "" : ""}
                    ref={params.InputProps.ref}
                    InputProps={{
                      ...params.InputParams,
                      endAdornment: key && (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="delete"
                            onClick={() => handleKeyAutoChange(null, "")}
                          >
                            <CloseIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={7}>
              <Input
                label="Value"
                placeholder="e.g.: Cache-Control..."
                fullWidth
                value={value}
                onChange={handleValueAutoChange}
              />
            </Grid>
            <Grid item xs={1} style={{ alignSelf: "center" }}>
              <div
                // className={classes.iconContainer}
                onClick={() => deleteIpParameterVal(index)}
                style={{ color: colors.red07, cursor: "pointer" }}
              >
                <Icons.DeleteOutlineOutlined />
              </div>
            </Grid>
          </Grid>
        );

      default:
        return null;
    }
  };

  return renderJSX(inputMode);
});
